import React from 'react';
import {Switch} from "@mui/joy";

// components
import BaseApi from "../../utils/BaseApi";
import dayjs from "dayjs";


class EstimationPhaseCompleted extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            phase: this.props.componentObj,
        };
    }

    async setOpposite() {
        const url = `estimation_phase/${this.props.componentObj.id}/`;
        const api = new BaseApi();
        let data = {
            completed: !this.state.phase.completed
        }
        if (!this.state.phase.completed){
            data.completed_on = dayjs().format('YYYY-MM-DDThh:mm:ss')
        }
        let response = await api.patch(
            url,
            data,
        );
        if (response.status === 200){
            this.setState({
                phase: response.data
            })
            if (this.props.callBack){
                await this.props.callBack();
            }
        }
    }

    render() {
        return(
            <Switch
                color={this.state.phase.completed?'success':'warning'}
                onChange={this.setOpposite.bind(this)}
                checked={this.state.phase.completed}
                disabled={!this.props.permission}
            />
        )
    }

}

export default EstimationPhaseCompleted